import { Stack } from '@fluentui/react';
import * as React from 'react';
import { CSSProperties } from 'react';

const iconMap = {
  NEW: {
    icon: 'HeartFill',
    color: '#F05A6D',
    textColor: 'lightred',
  },
  SEARCHING_DOCTOR: {
    icon: 'ProfileSearch',
    color: '#008080',
    textColor: 'lightblue',
  },
  DOCTOR_ASSIGNED: {
    icon: 'Lifesaver',
    color: '#4B0082',
    textColor: 'lightblue',
  },
  QUEUED: {
    icon: 'CollapseMenu',
    color: '#ffa500',
    textColor: 'orange',
  },
  DOCTOR_NOT_FOUND: {
    icon: 'Error',
    color: 'red',
    textColor: 'red',
  },
  DOCTOR_ENROUTE: {
    icon: 'CompassNW',
    color: '#6699ff',
    textColor: 'blue',
  },
  ACCEPTED: {
    icon: 'EventAccepted',
    color: '#84e184',
    textColor: 'lightgreen',
  },
  DOCTOR_ACKNOWLEDGED: {
    icon: 'RedEye',
    color: '#70dc70',
    textColor: 'lightgreen',
  },
  STARTED: {
    icon: 'Medical',
    color: '#28a428',
    textColor: 'lightgreen',
  },
  CANCELLED: {
    icon: 'Cancel',
    color: 'red',
    textColor: 'red',
  },
  FULLY_PAID: {
    icon: 'Money',
    color: '#216C2A',
    textColor: 'darkgreen',
  },
  FAILED_PREAUTH: {
    icon: 'Warning',
    color: '#ff4500',
    textColor: 'red',
  },
  REFUNDED: {
    icon: 'Money',
    color: '#216C2A',
    textColor: 'purple',
  },
  NOTIFICATION: {
    icon: 'Info',
    color: '#c6e2ff',
    textColor: 'darkpurple',
  },
  DEFAULT_ICON: {
    icon: 'Info',
    color: '#ff7e54',
    textColor: 'orange',
  },
};

export function getIconDetails(status: string) {
  let candidate = (iconMap as any)[status];
  if (!candidate) {
    candidate = iconMap.DEFAULT_ICON;
  }
  return { ...candidate };
}

export const VisitStatusIcon: React.FC<{ status: string; horizontal?: boolean }> = ({ status, horizontal }) => {
  const icon = getIconDetails(status);
  const horizontalGap = horizontal ? 5 : undefined;
  const horizontalTextCentering: CSSProperties = horizontal
    ? {
        display: 'flex',
        justifyContent: 'center',
        alignContent: 'center',
        flexDirection: 'column',
      }
    : {};

  return (
    <Stack style={{ textAlign: 'center', gap: horizontalGap }} horizontal={horizontal}>
      <i className={`ms-font-xl ms-Icon ms-Icon--${icon.icon}`} style={{ color: icon.color }} />
      <div className="ms-font-xs" style={{ color: icon.color, fontWeight: 600, ...horizontalTextCentering }}>
        {status.replace('_', ' ')}
      </div>
    </Stack>
  );
};
